export default __webpack_public_path__ + "static/media/left.d7f1e2ea.svg";